"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const http_status_codes_1 = require("http-status-codes");
/**
 * Base class for errors that have an http status code
 */
class StatusCodeError extends Error {
    /**
     * @param statusCode The http status code number
     * @param message The error message
     */
    constructor(statusCode, message) {
        super(message);
        this.statusCode = http_status_codes_1.StatusCodes.INTERNAL_SERVER_ERROR;
        this.statusCode = statusCode;
        this.name = this.constructor.name;
    }
}
exports.default = StatusCodeError;
